import React from 'react'
import WebApplication from '../../../../img/news-announcement/web-application.png';
import { ChevronLeft } from 'lucide-react';
import "./NewsAndAnnouncementDetail.scoped.scss"

export const ItemInformationMobile = ({ setOnOpenDetail, activeTab, announcement, news, listId, imageDefault }) => {

  return (
    <div className='item-information-card-mobile'>
      {activeTab !== "news" && (
        <div className='card-banner'>
          <div className='information-banner'>

            <img
              src={
                imageDefault.includes(news.find((x) => x.Id === listId)?.IconUrl) ?
                  `/img/vendors/news/${news.find((x) => x.Id === listId)?.IconUrl}.jpg`
                  : `api/Announcement/Image/${news.find((x) => x.Id === listId)?.IconUrl}`
              }
              alt={activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Topic || '' : news.find((x) => x.Id === listId)?.Topic}
              className="main-image"
            />

          </div>
          <ChevronLeft className='left-icon' onClick={() => setOnOpenDetail(0)} />
        </div>
      )}
      <div className='card-content'>
        <div className={`d-flex ${activeTab === "news" && "title-content"}`}>
          {activeTab === 'news' && (
            <>
              <ChevronLeft className='left-icon-news mr-1' onClick={() => setOnOpenDetail(0)} />
              <img src={`/img/vendors/icon/${announcement.find((x) => x.Id === listId)?.IconUrl}.png`} alt="icon" className='mr-3 mt-2' style={{ width: '36px', height: '36px' }} />
            </>
          )}
          <h2 className="main-title">{activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Topic || '' : news.find((x) => x.Id === listId)?.Topic}</h2>
        </div>
        <div className="description-content">
          <p dangerouslySetInnerHTML={{ __html: activeTab === "news" ? announcement.find((x) => x.Id === listId)?.Detail || '' : news.find((x) => x.Id === listId)?.Detail }} />
        </div>
      </div>
    </div>
  )
}
